var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');
var modbusDevice = Object.create(Model);

modbusDevice.name = 'Modbus Device';
modbusDevice['@class'] = 'ModbusDevice';
modbusDevice.url = 'modbusdevice';

modbusDevice.vm = {};

modbusDevice.fields = {
  parent: {
    default: null,
    hidden: true
  },
  name: {
    type: 'string',
    default: null,
    validators: {
      presence : true,
    }
  },
  template: {
    type: 'string',
    default: 'blank'
  },
  unitId: {
    type: 'number',
    default: 0,
    presence: true,
    numericality: {
      onlyInteger: true,
      greaterThanOrEqualTo: 0
    },
  }
};

modbusDevice.initForm = function (record) {
  loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/modbustemplates',
    method: 'GET'
  }).then(result => modbusDevice.templates = result)
  Model.initForm.call(modbusDevice, record);
};

var mapTemplatesToOptions = function () {
  var options = modbusDevice.templates.map(function (name) {
      return m('option', {value:name}, name);
  });
  options.unshift(m('option', {value:'Blank'}, 'Blank'));
  return options;
};

modbusDevice.view = function () {
  if(!modbusDevice.templates) return
  return  m('form', {role:'form'}, [
    modbusDevice.errorView(),
    m(formGroup, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        oninput: function(ev){modbusDevice.form.name(ev.target.value)},
        value: modbusDevice.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'length-input'}, 'Unit Id:'),
      m('input.form-control', {
        id:'length-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function(ev){modbusDevice.form.unitId(ev.target.value)}, 
        value: modbusDevice.form.unitId(),
      })
    ]),
    modbusDevice.record && modbusDevice.record['@rid'] ?
      ''
    :
      m(formGroup, [
        m('label', {for:'template-input'}, 'Template:'),
        m('select.form-control', 
          {
            id:"template-input", 
            onchange: function(ev){modbusDevice.form.template(ev.target.value)},
            value: modbusDevice.form.template()
          }, 
          mapTemplatesToOptions()
        )
      ])
  ])
};

module.exports = modbusDevice;